import { render, staticRenderFns } from "./CostProfit.vue?vue&type=template&id=d8ba15ac&scoped=true&"
import script from "./CostProfit.vue?vue&type=script&lang=js&"
export * from "./CostProfit.vue?vue&type=script&lang=js&"
import style0 from "./CostProfit.vue?vue&type=style&index=0&id=d8ba15ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8ba15ac",
  null
  
)

export default component.exports